import initialState from './initialState'

const SET_CUSTOMER_DATA = (state, customerData) => {
    state.customerData = customerData
}

const SET_DATA_STATUS = (state, dataStatus) => {
    state.dataStatus = dataStatus
}

const TOGGLE_CREATE_MODE = (state, bool) => {
    state.createMode = bool
}

const SET_RUT = (state, rut) => {
    state.customerData = { rut: rut }
}

const SET_ACTIVE_OFFICE_ID = (state, id) => {
    state.activeOfficeID = id
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = state => {
    Object.assign(state, initialState())
}

const SET_CORE_BUSINESS = (state, id) => {
    state.coreBusinessSelected = id
}

const SET_BRANCH_OFFICES = (state, offices) => (state.branchOffices = offices)
const SET_SELECTED_OFFICE = (state, id) => (state.selectedOffice = id)
const SET_CUSTOMER_READONLY = (state, bool) => (state.customerReadonly = bool)
const SET_CUSTOMER_PAYMENT_CONDITION_ID = (state, id) =>
    (state.customerPaymentConditionId = id)

export default {
    RESET_STATE,
    SET_CUSTOMER_DATA,
    SET_DATA_STATUS,
    TOGGLE_CREATE_MODE,
    SET_RUT,
    SET_ACTIVE_OFFICE_ID,
    SET_CORE_BUSINESS,
    SET_BRANCH_OFFICES,
    SET_SELECTED_OFFICE,
    SET_CUSTOMER_READONLY,
    SET_CUSTOMER_PAYMENT_CONDITION_ID,
}
